import { useQuery } from '@tanstack/react-query'
import classNames from 'classnames'
import { FC, useEffect } from 'react'

import useAppSessionStore from '@app/store/useAppSessionStore'
import { getHeadBanner } from '@shared/api/site-api/head-banner'
import { useAppModeStore } from '@shared/config/appMode.store'
import Alert from '@shared/ui/alert/Alert'
import HTMLRenderer from '@widgets/html_renderer/HtmlRenderer'

import styles from './global_alert_layout.module.css'


const GlobalAlertLayout: FC = () => {
    const showGlobalAlert = useAppSessionStore((state) => state.showGlobalAlert)
    const setShowGlobalAlert = useAppSessionStore((state) => state.setShowGlobalAlert)
    const appMode = useAppModeStore((state) => state.mode)

    const { data, isLoading } = useQuery({
        queryKey: ['headBanner'],
        queryFn: getHeadBanner,
    })

    const handleAlertClose = () => setShowGlobalAlert(false)

    const showAlert = appMode !== 'neuronext' && Boolean(data?.content?.trim())

    useEffect(() => {
        if (typeof showGlobalAlert === 'undefined' && data?.is_published) {
            setShowGlobalAlert(data?.is_published)
        }
    }, [data, setShowGlobalAlert, showGlobalAlert])

    return (
        <div className={classNames(
            styles.alertLayout,
            { [styles.open]: showGlobalAlert }
        )}>
            {!isLoading && showAlert && 
                <Alert
                    className={!showGlobalAlert ? styles.alertHidden : undefined}
                    onClose={ handleAlertClose }
                    text={ 
                        <HTMLRenderer html={ data?.content || '' } />
                    }
                />
            }
        </div>
    )
}

export default GlobalAlertLayout
